// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import ReactDOM from 'react-dom'

import './index.css'

const Modal = props => {
  return ReactDOM.createPortal(
    <div
      className='modal-background'
      onMouseDown={e => {e.stopPropagation(); props.onHide()}}
    >
      {props.children}
    </div>,
    document.getElementById('modal')
  )
}

export default Modal
